// extracted by mini-css-extract-plugin
export default {"root":"ProjectAboutStats_root__9i0yw","block":"ProjectAboutStats_block__aeccM","grid":"ProjectAboutStats_grid__30Itf","icon":"ProjectAboutStats_icon__5Xwlh"};